import Expense from "./routes/Expense/Expense.vue";
import UEC from "./routes/Uec/Uec.vue";

const pnlUploadRoutes = [
  {
    path: "expenseupload",
    name: "Expenseupload",
    component: Expense,
  },
  {
    path: "uec",
    name: "Uec",
    component: UEC,
  },

];

export default pnlUploadRoutes;
